var _regeneratorRuntime = require("/home/runner/work/degenalgorand.github.io/degenalgorand.github.io/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/degenalgorand.github.io/degenalgorand.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/runner/work/degenalgorand.github.io/degenalgorand.github.io/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/degenalgorand.github.io/degenalgorand.github.io/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require("./popup/popup"),
    openPopup = _require.openPopup;

var _require2 = require("./utils/utils"),
    sleep = _require2.sleep,
    prepareTxn = _require2.prepareTxn;

var Errors = require("./utils/errors");

var Messaging = require("./messaging/Messaging");

var bridge = new Messaging();
/**
 * @description Transaction hash
 * @typedef TxHash
 * @type {string}
 */

/**
 * @description Base64 string
 * @typedef Base64
 * @type {string}
 */

/**
  * @description Options
  * @typedef Options
  * @type {object}
  * @property {string} [bridgeUrl] Override wallet.myalgo.com default frame url.
  * @property {number} [timeout] Number of msec to wait the popup response, default value: 1600000 msec.
  * @property {boolean} [disableLedgerNano] It will disable ledger nano accounts and returns only mnemonic accounts.
  */

/**
 * @description Connect method settings
 * @typedef ConnectionSettings
 * @type {object}
 * @property {boolean} [shouldSelectOneAccount] Only returns one account
 * @property {boolean} [openManager] Open account manager
 */

/**
 * @description Algorand account address
 * @typedef Address
 * @type {string}
 */

/**
 * @description Payment transaction object
 * @typedef PaymentTxn
 * @type {object}
 * @property {"pay"} type Transaction type
 * @property {Address} from Sender Address
 * @property {Address} [to] Receiver Address
 * @property {number} fee Transaction fee (in mAlgos)
 * @property {number} [amount] Amount to transfer (in mAlgos)
 * @property {number} firstRound First block round
 * @property {number} lastRound Last block round
 * @property {Uint8Array|Base64} [note] Transaction note
 * @property {string} genesisID Algorand network genesis ID
 * @property {string} genesisHash Algorand network genesis hash
 * @property {Address} [reKeyTo] Change signer address
 * @property {boolean} [flatFee] flatFee (default: false)
 * @property {Buffer|Base64} [group] Group id
 * @property {Address} [closeRemainderTo] Close remainder to address
 */

/**
 * @description Asset transfer transaction object
 * @typedef AssetTransferTxn
 * @type {object}
 * @property {"axfer"} type Transaction type
 * @property {Address} from Sender Address
 * @property {Address} [to] Receiver Address
 * @property {number} fee Transaction fee (in mAlgos)
 * @property {number} [amount] Amount to transfer (in mAlgos)
 * @property {number} firstRound First block round
 * @property {number} lastRound Last block round
 * @property {Uint8Array|Base64} [note] Transaction note
 * @property {string} genesisID Algorand network genesis ID
 * @property {string} genesisHash Algorand network genesis hash
 * @property {Address} [reKeyTo] Change signer address
 * @property {boolean} [flatFee] flatFee (default: false)
 * @property {Address} [signer] Signer address
 * @property {Buffer|Base64} [group] Group id
 * @property {Address} [closeRemainderTo] Close remainder to address
 * @property {number} [assetIndex] Asset index
 * @property {Address} [assetRevocationTarget] Asset revocation address
 */

/**
 * @description Asset configuration transaction object
 * @typedef AssetConfigTxn
 * @type {object}
 * @property {"acfg"} type Transaction type
 * @property {Address} from Sender Address
 * @property {number} fee Transaction fee (in mAlgos)
 * @property {number} firstRound First block round
 * @property {number} lastRound Last block round
 * @property {Uint8Array|Base64} [note] Transaction note
 * @property {string} genesisID Algorand network genesis ID
 * @property {string} genesisHash Algorand network genesis hash
 * @property {Address} [reKeyTo] Change signer address
 * @property {boolean} [flatFee] flatFee (default: false)
 * @property {Address} [signer] Signer address
 * @property {Buffer|Base64} [group] Group id
 * @property {number} [assetIndex] Asset index
 * @property {number} [assetTotal] Asset total supply
 * @property {number} [assetDecimals] Asset decimals
 * @property {boolean} [assetDefaultFrozen] Default frozen
 * @property {Address} [assetManager] Asset manager address
 * @property {Address} [assetReserve] Asset reserve address
 * @property {Address} [assetFreeze] Asset freeze address
 * @property {Address} [assetClawback] Asset clawback address
 * @property {string} [assetUnitName] Asset unit name
 * @property {string} [assetName] Asset name
 * @property {string} [assetURL] Asset url
 * @property {string} [assetMetadataHash] Asset metadata hash
 * @property {boolean} [strictEmptyAddressChecking]
 */

/**
 * @description Key registration transaction object
 * @typedef KeyRegTxn
 * @type {object}
 * @property {"keyreg"} type Transaction type
 * @property {Address} from Sender Address
 * @property {number} fee Transaction fee (in mAlgos)
 * @property {number} firstRound First block round
 * @property {number} lastRound Last block round
 * @property {Uint8Array|Base64} [note] Transaction note
 * @property {string} genesisID Algorand network genesis ID
 * @property {string} genesisHash Algorand network genesis hash
 * @property {Address} [reKeyTo] Change signer address
 * @property {boolean} [flatFee] flatFee (default: false)
 * @property {Address} [signer] Signer address
 * @property {Buffer|Base64} [group] Group id
 * @property {string} [voteKey] Vote key
 * @property {string} [selectionKey] Selection key
 * @property {number} voteFirst Vote first round
 * @property {number} voteLast Vote last round
 * @property {number} [voteKeyDilution] Vote key dilution
 */

/**
 * @description Application call transaction object
 * @typedef ApplicationTxn
 * @type {object}
 * @property {"appl"} type Transaction type
 * @property {Address} from Sender Address
 * @property {number} fee Transaction fee (in mAlgos)
 * @property {number} firstRound First block round
 * @property {number} lastRound Last block round
 * @property {Uint8Array|Base64} [note] Transaction note
 * @property {string} genesisID Algorand network genesis ID
 * @property {string} genesisHash Algorand network genesis hash
 * @property {Address} [reKeyTo] Change signer address
 * @property {boolean} [flatFee] flatFee (default: false)
 * @property {Address} [signer] Signer address
 * @property {Buffer|Base64} [group] Group id
 * @property {number} [appIndex] Application id
 * @property {0|1|2|3|4|5} [appOnComplete]
 * @property {number} [appLocalInts]
 * @property {number} [appLocalByteSlices]
 * @property {number} [appGlobalInts]
 * @property {number} [appGlobalByteSlices]
 * @property {Uint8Array|Base64} [appApprovalProgram]
 * @property {Uint8Array|Base64} [appClearProgram]
 * @property {Uint8Array[]|Base64[]} [appArgs]
 * @property {Address[]} [appAccounts]
 * @property {number[]} [appForeignApps]
 * @property {number[]} [appForeignAssets]
 */

/**
 * @description Transaction Object
 * @typedef Transaction
 * @type {PaymentTxn | AssetTransferTxn | AssetConfigTxn | KeyRegTxn | ApplicationTxn}
 */

/**
 * @typedef EncodedTransaction
 * @type {Uint8Array|Base64} Algorand Encoded Transaction
 */

/**
 * @typedef SignedTx
 * @type {object}
 * @property {TxHash} txID Transaction hash
 * @property {Uint8Array} blob Signed transaction
 */

var MyAlgoConnect = /*#__PURE__*/function () {
  "use strict";

  /**
   * @constructor
   * @param {Options} [options] Operation options
   */
  function MyAlgoConnect(options) {
    _classCallCheck(this, MyAlgoConnect);

    /**
     * @access private
     * @type {Messaging}
     */
    this.bridge = bridge;
    /**
     * @access private
     * @type {number} Popup Timeout
     */

    this.timeout = options && options.timeout ? options.timeout : 1600000;
    /**
     * @access private
     * @type {string} Frame url
     */

    this.url = options && options.bridgeUrl ? options.bridgeUrl : "https://wallet.myalgo.com/bridge";
    if (this.url.endsWith("/")) this.url = this.url.slice(0, -1);
    /**
     * @access private
     * @description This is used to reuse the current connect opened popup
     * @type {Window|null}
     */

    this.currentConnectPopup = null;
    /**
     * @access private
     * @description This is used to reuse the current signtx opened popup
     * @type {Window|null}
     */

    this.currentSigntxPopup = null;
    /**
     * @access private
     * @description This is used to reuse the current signlogic opened popup
     * @type {Window|null}
     */

    this.currentSignLogicSigPopup = null;
    /**
     * @access private
     * @description Replace default bridge options
     * @type {import("@randlabs/communication-bridge").sendMessageOptions}
     */

    this.options = {
      waitForReply: true,
      timeout: this.timeout
    };
    /**
     * @access private
     * @description Disable ledger nano
     * @type {boolean}
     */

    this.disableLedgerNano = options && options.disableLedgerNano ? options.disableLedgerNano : false;
  }
  /**
   * @async
   * @access public
   * @description Open a new window to load accounts from storage.
   * @param {ConnectionSettings} settings Connect settings
   * @returns {Promise<string[]>} Returns allowed accounts by the user.
   */


  _createClass(MyAlgoConnect, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var settings,
            res,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                settings = _args.length > 0 && _args[0] !== undefined ? _args[0] : {
                  shouldSelectOneAccount: false,
                  openManager: false
                };

                if (this.currentConnectPopup) {
                  if (this.currentConnectPopup.closed) {
                    this.currentConnectPopup = null;
                  } else {
                    this.focusWindow(this.currentConnectPopup);
                  }
                }

                _context.prev = 2;
                this.currentConnectPopup = openPopup(this.url + "/connect.html");
                _context.next = 6;
                return this.waitForWindowToLoad(this.currentConnectPopup);

              case 6:
                _context.next = 8;
                return this.bridge.sendMessage(this.currentConnectPopup, {
                  method: "unlock",
                  params: Object.assign(settings, {
                    disableLedgerNano: this.disableLedgerNano
                  })
                }, this.url, this.options);

              case 8:
                res = _context.sent;
                this.closeWindow(this.currentConnectPopup);
                this.currentConnectPopup = null;

                if (!(res.status === "error")) {
                  _context.next = 13;
                  break;
                }

                throw new Error(res.message);

              case 13:
                return _context.abrupt("return", res.data.accounts);

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](2);
                this.closeWindow(this.currentConnectPopup);
                this.currentConnectPopup = null;
                throw _context.t0;

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 16]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
    /**
     * @async
     * @access public
     * @description Open a new window to sign transaction.
     * @param {Transaction|Transaction[]|EncodedTransaction|EncodedTransaction[]} transaction Transaction object or a Transaction array.
     * (The signer account must be the same for all transactions).
     * @returns {(SignedTx|SignedTx[])} Returns transaction blob or an Array of blobs, depends if the
     * transaction was an object or an array.
     */

  }, {
    key: "signTransaction",
    value: function () {
      var _signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(transaction) {
        var txn, res, result, _iterator, _step, t;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.currentSigntxPopup) {
                  if (this.currentSigntxPopup.closed) {
                    this.currentSigntxPopup = null;
                  } else {
                    this.focusWindow(this.currentSigntxPopup);
                  }
                }

                if (Array.isArray(transaction)) txn = Array.from(transaction).map(function (tx) {
                  return prepareTxn(tx);
                });else txn = prepareTxn(transaction);
                _context2.prev = 2;
                this.currentSigntxPopup = openPopup(this.url + "/signtx.html");
                _context2.next = 6;
                return this.waitForWindowToLoad(this.currentSigntxPopup);

              case 6:
                _context2.next = 8;
                return this.bridge.sendMessage(this.currentSigntxPopup, {
                  method: "transaction",
                  params: {
                    txn: txn,
                    settings: {
                      disableLedgerNano: this.disableLedgerNano
                    }
                  }
                }, this.url, this.options);

              case 8:
                res = _context2.sent;
                this.closeWindow(this.currentSigntxPopup);
                this.currentSigntxPopup = null;

                if (!(res.status === "error")) {
                  _context2.next = 13;
                  break;
                }

                throw new Error(res.message);

              case 13:
                if (!Array.isArray(res.data)) {
                  _context2.next = 18;
                  break;
                }

                result = [];
                _iterator = _createForOfIteratorHelper(res.data);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    t = _step.value;
                    t.blob = new Uint8Array(Buffer.from(t.blob, "hex"));
                    result.push(t);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                return _context2.abrupt("return", result);

              case 18:
                res.data.blob = new Uint8Array(Buffer.from(res.data.blob, "hex"));
                return _context2.abrupt("return", res.data);

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](2);
                this.closeWindow(this.currentSigntxPopup);
                this.currentSigntxPopup = null;
                throw _context2.t0;

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 22]]);
      }));

      function signTransaction(_x) {
        return _signTransaction.apply(this, arguments);
      }

      return signTransaction;
    }()
    /**
     * @async
     * @access public
     * @description Open a new window to sign a teal program.
     * @param {Uint8Array|Base64} logic LogicSig program
     * @param {Address} address Signer Address
     * @returns {Uint8Array} Returns logicsig blob
     */

  }, {
    key: "signLogicSig",
    value: function () {
      var _signLogicSig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(logic, address) {
        var logicInBase64, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.currentSignLogicSigPopup) {
                  if (this.currentSignLogicSigPopup.closed) {
                    this.currentSignLogicSigPopup = null;
                  } else {
                    this.focusWindow(this.currentSignLogicSigPopup);
                  }
                }

                _context3.prev = 1;
                this.currentSignLogicSigPopup = openPopup(this.url + "/logicsigtx.html");
                _context3.next = 5;
                return this.waitForWindowToLoad(this.currentSignLogicSigPopup);

              case 5:
                // Send program
                logicInBase64 = logic;
                if (logic.constructor === Uint8Array) logicInBase64 = Buffer.from(logic).toString("base64");
                _context3.next = 9;
                return this.bridge.sendMessage(this.currentSignLogicSigPopup, {
                  method: "logicsig",
                  params: {
                    logic: logicInBase64,
                    address: address
                  }
                }, this.url, this.options);

              case 9:
                res = _context3.sent;
                this.closeWindow(this.currentSignLogicSigPopup);
                this.currentSignLogicSigPopup = null;

                if (!(res.status === "error")) {
                  _context3.next = 14;
                  break;
                }

                throw new Error(res.message);

              case 14:
                return _context3.abrupt("return", new Uint8Array(Buffer.from(res.data.signedTeal, "base64")));

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](1);
                this.closeWindow(this.currentSignLogicSigPopup);
                this.currentSignLogicSigPopup = null;
                throw _context3.t0;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 17]]);
      }));

      function signLogicSig(_x2, _x3) {
        return _signLogicSig.apply(this, arguments);
      }

      return signLogicSig;
    }()
    /**
     * @async
     * @access private
     * @description Wait until the window opened loads.
     * @param {Window} targetWindow Window opened context.
     * @param {number} retries Times to retry before throw an error.
     * @returns {Promise<void>} Throw error if the window does not load.
     */

  }, {
    key: "waitForWindowToLoad",
    value: function () {
      var _waitForWindowToLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(targetWindow) {
        var retries,
            i,
            res,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                retries = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 30;
                i = 0;

              case 2:
                if (!(i < retries)) {
                  _context4.next = 20;
                  break;
                }

                _context4.next = 5;
                return sleep(300);

              case 5:
                if (targetWindow) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("break", 20);

              case 7:
                _context4.prev = 7;
                _context4.next = 10;
                return bridge.sendMessage(targetWindow, {
                  method: "status"
                }, this.url);

              case 10:
                res = _context4.sent;

                if (!(res.status == "success")) {
                  _context4.next = 13;
                  break;
                }

                return _context4.abrupt("return");

              case 13:
                _context4.next = 17;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](7);

              case 17:
                i++;
                _context4.next = 2;
                break;

              case 20:
                throw new Error(Errors.WINDOW_NOT_LOADED);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[7, 15]]);
      }));

      function waitForWindowToLoad(_x4) {
        return _waitForWindowToLoad.apply(this, arguments);
      }

      return waitForWindowToLoad;
    }()
    /**
     * @access private
     * @description Safely close an opened window
     * @param {Window} window Window object
     * @returns {void}
     */

  }, {
    key: "closeWindow",
    value: function closeWindow(window) {
      if (window && !window.closed && window.close) {
        window.close();
      }
    }
    /**
     * @access private
     * @description Focus current popup
     * @param {Window} window Window object
     * @returns {void}
     * @throws {"Windows is opened"}
     */

  }, {
    key: "focusWindow",
    value: function focusWindow(window) {
      if (window && window.focus) {
        window.focus();
        throw new Error(Errors.WINDOW_IS_OPENED);
      } else {
        throw new Error(Errors.INVALID_WINDOW);
      }
    }
  }]);

  return MyAlgoConnect;
}();

module.exports = MyAlgoConnect;